module.exports = "/assets/67b31fc9c609cd8dba256ce92698cf47.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BV.png
// module id = 1244
// module chunks = 0